module.exports = __webpack_public_path__ + "assets/img/join4.2b206ed8.png";